import { Injectable, OnDestroy, signal } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { Observable, Subject } from 'rxjs'
import { NotificationModel } from '../../commons/components/notification/models/notification.model'

export enum DisplayStateValues {
  settings = 'settings',
  state = 'state',
  healthMonitoring = 'healthMonitoring',
  enterManualTouaregController = 'enterManualTouaregController',
}

export interface DisplayState {
  currentState: DisplayStateValues
  openByUser: boolean
}

const INITIAL_DISPLAY_STATE = {
  currentState: DisplayStateValues.state,
  openByUser: false,
}

@Injectable()
export class TouaregControlDisplayService implements OnDestroy {
  private _notificationToRemove: NotificationModel | undefined
  private readonly _display = signal<DisplayState>(INITIAL_DISPLAY_STATE)
  public readonly displayState = this._display.asReadonly()
  public readonly display$: Observable<DisplayState> = toObservable(this._display)
  public readonly closeUI$ = new Subject<boolean>()

  private readonly _pairingsInfoOpen = signal<any>({})
  public readonly pairingsInfoOpen = this._pairingsInfoOpen.asReadonly()
  public readonly pairingsInfoOpen$: Observable<any> = toObservable(this._pairingsInfoOpen)

  public get display(): DisplayState {
    return this._display()
  }

  public get notificationToRemove(): NotificationModel | undefined {
    return this._notificationToRemove
  }

  constructor() {}

  public setNotificationToRemove(notification: NotificationModel) {
    this._notificationToRemove = notification
  }

  public closeUI() {
    this.closeUI$.next(true)
  }

  public resetPairingInfoOpen() {
    this._pairingsInfoOpen.set({})
  }

  public setPairingInfoOpen(id: string | number) {
    const values = { ...this._pairingsInfoOpen(), [id]: true }
    this._pairingsInfoOpen.set(values)
  }

  public setPairingInfoClose(id: string | number) {
    const values = { ...this._pairingsInfoOpen(), [id]: false }
    this._pairingsInfoOpen.set(values)
  }

  public settingsOn() {
    const current = this._display()
    this._display.set({
      ...current,
      currentState: DisplayStateValues.settings,
    })
  }

  public healthMonitoringOn() {
    const current = this._display()
    this._display.set({
      ...current,
      currentState: DisplayStateValues.healthMonitoring,
    })
  }

  public stateOn() {
    const current = this._display()
    this._display.set({
      ...current,
      currentState: DisplayStateValues.state,
    })
  }

  public enterManualTouaregControllerOn() {
    const current = this._display()
    this._display.set({
      ...current,
      openByUser: true,
    })
  }

  public enterManualTouaregControllerOff() {
    const current = this._display()
    this._display.set({
      ...current,
      openByUser: false,
    })
  }

  ngOnDestroy() {}
}
